<template>
  <v-layout>
    <v-col class="custom-content-container pt-0" cols="12" md="12" sm="12">
      <template v-if="false && isDialog">
        <v-row v-for="(row, index) in contactPersons" :key="index">
          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="t-salutation"
              >Salutation</label
            >
            <v-select
              id="t-salutation"
              :menu-props="{ offsetY: true }"
              v-model.trim="row.title"
              :items="salutationList"
              dense
              filled
              item-text="text"
              item-value="value"
              item-color="cyan"
              placeholder="Salutation"
              solo
              flat
              color="cyan"
            ></v-select>
          </v-col>
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="t-first_name"
              >First Name</label
            >
            <v-text-field
              id="t-first_name"
              v-model.trim="row.first_name"
              :rules="[
                validateRules.required(row.first_name, 'first name'),
                validateRules.minLength(row.first_name, 'first name', 2),
                validateRules.maxLength(row.first_name, 'first name', 100),
              ]"
              dense
              filled
              placeholder="First Name"
              solo
              flat
              v-on:keyup="appendDialogDisplayName(index)"
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <label class="font-size-16 font-weight-500" for="t-last_name"
              >Last Name</label
            >
            <v-text-field
              id="t-last_name"
              v-model.trim="row.last_name"
              :rules="[
                validateRules.minLength(row.last_name, 'last name', 2),
                validateRules.maxLength(row.last_name, 'last name', 100),
              ]"
              dense
              filled
              placeholder="Last Name"
              solo
              flat
              v-on:keyup="appendDialogDisplayName(index)"
              color="cyan"
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="t-display_name"
              >Display Name</label
            >
            <v-text-field
              id="t-display_name"
              v-model.trim="row.display_name"
              :rules="[
                validateRules.required(row.display_name, 'display name'),
                validateRules.minLength(row.display_name, 'display name', 2),
                validateRules.maxLength(row.display_name, 'display name', 100),
              ]"
              dense
              filled
              placeholder="Display Name"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="t-primary_phone"
              >Mobile / Landline Number</label
            >
            <PhoneTextField
              id="t-primary_phone"
              v-model="row.primary_phone"
              :value="row.primary_phone"
              required
            >
            </PhoneTextField>
          </v-col>
          <v-col md="4">
            <label
              class="font-size-16 font-weight-500 required"
              for="t-primary_email"
              >Email Address</label
            >
            <v-text-field
              id="t-primary_email"
              v-model.trim="row.primary_email"
              :rules="[
                validateRules.required(row.primary_email, 'email'),
                validateRules.validEmail(row.primary_email, 'email'),
                validateRules.minLength(row.primary_email, 'email', 2),
                validateRules.maxLength(row.primary_email, 'email', 100),
              ]"
              dense
              filled
              placeholder="Email"
              solo
              flat
              color="cyan"
              class="required-field"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: 90vh; position: relative"
        >
          <v-layout class="d-block">
            <v-row>
              <v-col class="iv-custom-field pt-0" cols="12" md="12" sm="12">
                <v-container fluid class="pt-0">
                  <v-row>
                    <v-col class="text-right pt-0">
                      <v-btn
                        class="my-2 custom-bold-button white--text"
                        v-on:click="addContactPerson()"
                        color="cyan"
                        small
                        depressed
                      >
                        Add Contact Person
                      </v-btn>
                    </v-col>
                  </v-row>
                  <table width="100%" class="contact-person-table">
                    <colgroup>
                      <col style="width: 3%" />
                      <col style="width: 7%" />
                      <col style="width: 14%" />
                      <col style="width: 14%" />
                      <col style="width: 20%" />
                      <col style="width: 9%" />
                      <col style="width: 8%" />
                      <col style="width: 10%" />
                      <col style="width: 7%" />
                      <col style="width: 8%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="simple-table-th">#</th>
                        <th class="simple-table-th">Salutation</th>
                        <th class="simple-table-th">First Name</th>
                        <th class="simple-table-th">Last Name</th>
                        <th class="simple-table-th">Display Name</th>
                        <th class="simple-table-th">Mobile Number</th>
                        <th class="simple-table-th">
                          <template v-if="detail.company_type == 'company'"
                            >DID</template
                          >
                          <template v-if="detail.company_type == 'personal'"
                            >Landline Number</template
                          >
                        </th>
                        <th class="simple-table-th">Email Address</th>
                        <th class="simple-table-th">Position</th>
                        <th class="simple-table-th"></th>
                      </tr>
                    </thead>
                    <tbody v-if="contactPersons.length">
                      <tr v-for="(row, index) in contactPersons" :key="index">
                        <td class="cursor-default simple-table-td">
                          {{ index + 1 }}
                        </td>
                        <td
                          class="cursor-default simple-table-td text-capitalize"
                        >
                          {{ row.title }}.
                        </td>
                        <td class="cursor-default simple-table-td">
                          {{ row.first_name }}
                        </td>
                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.last_name">
                            {{ row.last_name }}
                          </template>
                          <em v-else class="text-muted"> no last name</em>
                        </td>
                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.display_name">
                            {{ row.display_name }}
                          </template>
                          <em v-else class="text-muted"> no display name</em>
                        </td>
                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.primary_phone">
                            {{ row.primary_phone }}
                          </template>
                          <em v-else class="text-muted"> no number</em>
                        </td>
                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.did">
                            {{ row.did }}
                          </template>
                          <em v-else class="text-muted">
                            <template v-if="detail.company_type == 'company'"
                              >no did</template
                            >
                            <template v-if="detail.company_type == 'personal'"
                              >no landline number</template
                            ></em
                          >
                        </td>
                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.primary_email">
                            {{ row.primary_email }}
                          </template>
                          <em v-else class="text-muted"> no email adddress</em>
                        </td>

                        <td class="cursor-default simple-table-td">
                          <template v-if="row && row.position">
                            {{ row.position }}
                          </template>

                          <template v-else-if="row && row.designation">
                            {{ row.designation }}
                          </template>

                          <em v-else class="text-muted">no position</em>
                        </td>

                        <td class="simple-table-td">
                          <v-btn
                            class="mx-2 custom-bold-button white--text rounded"
                            color="cyan"
                            depressed
                            outlined
                            min-width="34px"
                            width="34px"
                            v-on:click="updateContactPerson(row)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>

                          <template v-if="index > 0">
                            <v-menu
                              top
                              content-class="delete-small-confirm"
                              v-model="row.menu"
                              :close-on-content-click="false"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mx-2 rounded"
                                  color="red lighten-1"
                                  depressed
                                  outlined
                                  min-width="34px"
                                  width="34px"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon small dark>
                                    mdi-trash-can-outline</v-icon
                                  >
                                </v-btn>
                              </template>
                              <DeleteSmallConfirm
                                :message="`Are you sure, you want to delete <span class='red--text'>${row.display_name}</span> ?`"
                                v-on:cancel="row['menu'] = false"
                                v-on:success="removeContactPerson(index)"
                              ></DeleteSmallConfirm>
                            </v-menu>
                          </template>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot v-else>
                      <tr>
                        <td colspan="8">
                          <p
                            class="my-4 row-not-found text-center font-weight-500 font-size-16"
                          >
                            <img
                              :src="$assetURL('media/error/empty.png')"
                              class="row-not-found-image"
                            />
                            Uhh... There are no contact person at the moment.
                          </p>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </v-container>
              </v-col>
            </v-row>
          </v-layout>
        </perfect-scrollbar>

        <template v-if="dialog">
          <CreateContactPerson
            :person-alldata="editAllData"
            v-model="contactPersons"
            :person-dialog="dialog"
            :customer-type="detail.company_type"
            :person-uuid="editPersonUUID"
            v-on:close="
              editPersonUUID = null;
              dialog = false;
            "
            :do-update="updateSelf"
          ></CreateContactPerson>
        </template>
      </template>
    </v-col>
  </v-layout>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CustomerMixin from "@/core/plugins/customer-mixin";
import DeleteSmallConfirm from "@/view/pages/partials/DeleteSmallConfirm";
import CreateContactPerson from "@/view/pages/customer/create-or-update/Create-Contact-Person";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import { CustomerEventBus } from "@/core/lib/customer.lib";

import { v4 as uuidv4 } from "uuid";

export default {
  name: "contact-persons",
  title: "Customer",
  mixins: [CommonMixin, ValidationMixin, CustomerMixin],
  props: {
    detail: {
      type: Object,
      default: function () {
        return {};
      },
    },
    customer: {
      type: Object,
      default: function () {
        return {};
      },
    },
    lead: {
      type: Object,
      default: () => ({}),
    },
    isDialog: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Number,
      default: 0,
    },
    persons: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editAllData: {},
      dialog: false,
      updateSelf: false,
      editPersonUUID: null,
      contactPerson: {
        id: null,
        uuid: uuidv4(),
        title: "mr",
        first_name: null,
        last_name: null,
        display_name: null,
        primary_email: null,
        emails: [],
        primary_phone: null,
        did: null,
        will_notified: 1,
        position: null,
        default: 0,
      },
      contactPersons: [],
      generatedDefaultContactUUID: null,
    };
  },
  watch: {
    persons: {
      deep: true,
      handler() {
        this.makeDefaultEntry();
      },
    },
    lead: {
      deep: true,
      handler() {
        this.makeDefaultEntry();
      },
    },
    contactPersons: {
      deep: true,
      immediate: true,
      handler(param) {
        let result = this.lodash.cloneDeep(param);
        this.$emit("saveContactPerson", result);
      },
    },
    detail: {
      deep: true,
      handler() {
        this.makeDefaultEntry();
      },
    },
  },
  methods: {
    updateContactPerson(param) {
      this.editPersonUUID = param.uuid;
      //  console.log({editPersonUUID: this.editPersonUUID});
      this.editAllData = param;
      this.contactPerson = param;
      this.updateSelf = true;
      this.dialog = true;
    },
    addContactPerson() {
      this.editPersonUUID = null;
      this.updateSelf = false;
      this.dialog = true;
    },
    appendDisplayName() {
      const result = [];
      const { first_name, last_name } = this.contactPerson;
      if (first_name) {
        result.push(first_name);
      }
      if (last_name) {
        result.push(last_name);
      }
      this.contactPerson.display_name = result.join(" ");
    },
    appendDialogDisplayName(index) {
      const result = [];
      const { first_name, last_name } = this.contactPersons[index];
      if (first_name) {
        result.push(first_name);
      }
      if (last_name) {
        result.push(last_name);
      }
      this.contactPersons[index].display_name = result.join(" ");
    },
    makeDefaultEntry() {
      const _this = this;
      try {
        const isLeadConversion = Boolean(this.lead && this.lead.id);
        const leadPersons = Array.isArray(this.persons) ? this.persons : [];
        if (isLeadConversion && this.generatedDefaultContactUUID) {
          this.contactPersons = this.contactPersons.filter(
            (person) => person.uuid !== this.generatedDefaultContactUUID
          );
          this.generatedDefaultContactUUID = null;
        }
        /* let emailData = _this.lodash.filter(
          _this.detail.details,
          function (data) {
            return data.type === 1;
          }
        ); */
        /*    let contactData = _this.lodash.filter(
          _this.detail.details,
          function (data) {
            return data.type === 2;
          }
        ); */
        const result = [];
        const { first_name, last_name } = this.detail;
        if (first_name) {
          result.push(first_name);
        }
        if (last_name) {
          result.push(last_name);
        }
        /*   if (!this.detail.primary) {
              this.detail.display_name = result.join(" ");
            } */
        if (_this.detail.first_name && !isLeadConversion) {
          let contactIndex = this.contactPersons.length + 1;

          // Determine which email and phone fields to use based on customer type
          const email =
            _this.detail.company_type === "personal"
              ? _this.detail.person_email
              : _this.detail.company_email;
          const phone =
            _this.detail.company_type === "personal"
              ? _this.detail.mobile_number
              : _this.detail.company_number;

          let firstEntry = {
            id: null,
            uuid: uuidv4(),
            menu: false,
            type: "customer",
            title: _this.lodash.toString(_this.detail.salutation),
            first_name: _this.lodash.toString(_this.detail.first_name),
            last_name: _this.lodash.toString(_this.detail.last_name),
            display_name: result.join(" "),
            primary_email: email ? _this.lodash.toString(email) : null,
            primary_phone: phone ? _this.lodash.toString(phone) : null,
            default: 1,
            will_notified: 1,
            position: null,
            did: _this.detail.landline_number
              ? _this.lodash.toString(_this.detail.landline_number)
              : null,
            contactIndex: contactIndex,
            designation: null,
          };
          if (_this.contactPersons.length) {
            // Only preserve old values if new values from detail are not set
            firstEntry.primary_phone = phone
              ? _this.lodash.toString(phone)
              : _this.contactPersons[0].primary_phone;
            firstEntry.primary_email = email
              ? _this.lodash.toString(email)
              : _this.contactPersons[0].primary_email;
            firstEntry.did = _this.detail.landline_number
              ? _this.lodash.toString(_this.detail.landline_number)
              : _this.contactPersons[0].did;
          }
          // console.log(_this.detail, "_this.detail");
          console.log(_this.contactPersons, "contactPersons");
          //  console.log(firstEntry, "firstEntry");
          firstEntry.emails = [firstEntry.primary_email];
          _this.generatedDefaultContactUUID = firstEntry.uuid;
          _this.contactPersons.splice(0, 1, firstEntry);
        }

        if (leadPersons.length > 0) {
          leadPersons.forEach((person) => {
            // Check if person already exists by name or email
            const existingPerson = this.contactPersons.find(
              (existing) =>
                existing.first_name === person.first_name ||
                (person.email &&
                  existing.primary_email === person.primary_email)
            );

            if (!existingPerson) {
              const newEntry = {
                id: null,
                uuid: uuidv4(),
                menu: false,
                title: "mr",
                type: "customer",
                first_name: this.lodash.toString(person.first_name),
                last_name: this.lodash.toString(person.last_name),
                display_name: person.display_name || null,
                primary_email: person.primary_email || null,
                primary_phone: person.primary_phone || person.phone || null,
                did: person.did || null,
                default: Number(person.default ?? person.primary) === 1 ? 1 : 0,
                will_notified: 0,
                // fallback to designation when position is not provided
                position: person.position || person.designation || null,
                designation: null,
                contactIndex: this.contactPersons.length + 1,
              };

              this.contactPersons.push(newEntry);
            }
          });
        }
      } catch (error) {
        _this.contactPersons.splice(0, 1);
        _this.logError(error);
      }
    },
    createDisplayName() {
      let firstname = "";
      if (this.detail.first_name) {
        firstname = this.detail.first_name.toLowerCase();
      }
      let lastname = "";
      if (this.detail.last_name) {
        lastname = this.detail.last_name.toLowerCase();
      }
      return firstname + lastname;
    },
    pushContactPerson() {
      this.contactPersons.push({
        id: null,
        uuid: uuidv4(),
        title: "mr",
        menu: false,
        first_name: null,
        last_name: null,
        display_name: null,
        primary_email: null,
        emails: [],
        primary_phone: null,
        did: null,
        will_notified: 1,
        position: null,
        default: 0,
        designation: null,
      });
    },
    removeContactPerson(index) {
      this.contactPersons.splice(index, 1);
    },
  },
  components: {
    PhoneTextField,
    DeleteSmallConfirm,
    CreateContactPerson,
  },
  mounted() {
    if (this.isDialog) {
      if (this.contactPersons.length <= 0) {
        this.contactPersons.push({
          id: null,
          uuid: uuidv4(),
          title: "mr",
          menu: false,
          first_name: null,
          last_name: null,
          display_name: null,
          primary_email: null,
          primary_phone: null,
          did: null,
          emails: [],
          will_notified: 1,
          position: null,
          default: 0,
          designation: null,
        });
      }
    }
    this.makeDefaultEntry();
    if (this.person > 0) {
      this.contactPersons = [this.getPersonById(this.customer, this.person)];
    }
    CustomerEventBus.$on("update:default-contact-person", () => {
      this.makeDefaultEntry();
    });
  },
};
</script>

<style scoped>
.contact-person-table {
  table-layout: fixed;
}

.contact-person-table th,
.contact-person-table td {
  white-space: normal;
  overflow-wrap: anywhere;
}
</style>
